
export const statesList = [
  {
    id: 1,
    label: "Andhra Pradesh",
    district: [
      { id: 1, city: "Alluri Sitharama Raju", lat: "18.1333", lng: "82.3667" },
      { id: 2, city: "Anakapalli", lat: "17.6910", lng: "83.0047" },
      { id: 3, city: "Anantapur", lat: "14.6819", lng: "77.6006" },
      { id: 4, city: "Bapatla", lat: "15.9041", lng: "80.4671" },
      { id: 5, city: "Chittoor", lat: "13.2172", lng: "79.1000" },
      { id: 6, city: "Dr. B.R. Ambedkar Konaseema", lat: "16.6167", lng: "82.0167" },
      { id: 7, city: "East Godavari", lat: "17.0167", lng: "82.2167" },
      { id: 8, city: "Eluru", lat: "16.7107", lng: "81.0952" },
      { id: 9, city: "Guntur", lat: "16.3067", lng: "80.4365" },
      { id: 10, city: "Kakinada", lat: "16.9891", lng: "82.2475" },
      { id: 11, city: "Krishna", lat: "16.5732", lng: "81.5300" },
      { id: 12, city: "Kurnool", lat: "15.8281", lng: "78.0373" },
      { id: 13, city: "Nandyal", lat: "15.4833", lng: "78.4833" },
      { id: 14, city: "Nellore", lat: "14.4426", lng: "79.9865" },
      { id: 15, city: "NTR", lat: "16.5000", lng: "80.6167" },
      { id: 16, city: "Palnadu", lat: "16.5600", lng: "79.6000" },
      { id: 17, city: "Parvathipuram Manyam", lat: "18.7833", lng: "83.4167" },
      { id: 18, city: "Prakasam", lat: "15.5000", lng: "80.0500" },
      { id: 19, city: "Srikakulam", lat: "18.2969", lng: "83.8973" },
      { id: 20, city: "Sri Potti Sriramulu Nellore", lat: "14.4426", lng: "79.9865" },
      { id: 21, city: "Sri Sathya Sai", lat: "14.6833", lng: "77.6000" },
      { id: 22, city: "Tirupati", lat: "13.6288", lng: "79.4192" },
      { id: 23, city: "Visakhapatnam", lat: "17.6868", lng: "83.2185" },
      { id: 24, city: "Vizianagaram", lat: "18.1167", lng: "83.4167" },
      { id: 25, city: "West Godavari", lat: "16.8000", lng: "81.5000" },
      { id: 26, city: "YSR Kadapa", lat: "14.4673", lng: "78.8242" },
    ],
  },
  {
    id: 2,
    label: "Arunachal Pradesh",
    district: [
      { id: 1, city: "Anjaw", lat: "28.0667", lng: "97.0833" },
      { id: 2, city: "Changlang", lat: "27.1167", lng: "95.7167" },
      { id: 3, city: "Dibang Valley", lat: "28.7333", lng: "95.9333" },
      { id: 4, city: "East Kameng", lat: "27.3167", lng: "93.0167" },
      { id: 5, city: "East Siang", lat: "28.0667", lng: "95.3333" },
      { id: 6, city: "Kamle", lat: "27.8500", lng: "93.1500" },
      { id: 7, city: "Kra Daadi", lat: "28.1500", lng: "94.0333" },
      { id: 8, city: "Kurung Kumey", lat: "28.1333", lng: "93.2833" },
      { id: 9, city: "Lepa Rada", lat: "28.3333", lng: "94.5833" },
      { id: 10, city: "Lohit", lat: "27.9200", lng: "96.3300" },
      { id: 11, city: "Longding", lat: "27.0500", lng: "95.4000" },
      { id: 12, city: "Lower Dibang Valley", lat: "28.1000", lng: "95.9333" },
      { id: 13, city: "Lower Siang", lat: "28.0833", lng: "94.7167" },
      { id: 14, city: "Lower Subansiri", lat: "27.6000", lng: "93.8333" },
      { id: 15, city: "Namsai", lat: "27.9167", lng: "95.9333" },
      { id: 16, city: "Pakke Kessang", lat: "27.1833", lng: "93.0167" },
      { id: 17, city: "Papum Pare", lat: "27.1500", lng: "93.6500" },
      { id: 18, city: "Shi Yomi", lat: "28.4833", lng: "94.4833" },
      { id: 19, city: "Siang", lat: "28.3833", lng: "94.8000" },
      { id: 20, city: "Tawang", lat: "27.5864", lng: "91.8687" },
      { id: 21, city: "Tirap", lat: "27.3000", lng: "95.4000" },
      { id: 22, city: "Upper Siang", lat: "28.7167", lng: "95.3500" },
      { id: 23, city: "Upper Subansiri", lat: "28.0000", lng: "94.0000" },
      { id: 24, city: "West Kameng", lat: "27.3167", lng: "92.4000" },
      { id: 25, city: "West Siang", lat: "28.3833", lng: "94.7167" },
      { id: 26, city: "Itanagar (Capital Complex)", lat: "27.0844", lng: "93.6053" },
    ],
  },
  {
    id: 3,
    label: "Assam",
    district: [
      { id: 1, city: "Baksa", lat: "26.6900", lng: "91.4600" },
      { id: 2, city: "Barpeta", lat: "26.3200", lng: "91.0000" },
      { id: 3, city: "Biswanath", lat: "26.7181", lng: "93.1385" },
      { id: 4, city: "Bongaigaon", lat: "26.4400", lng: "90.5600" },
      { id: 5, city: "Cachar", lat: "24.8333", lng: "92.7789" },
      { id: 6, city: "Charaideo", lat: "27.0400", lng: "95.0400" },
      { id: 7, city: "Chirang", lat: "26.5000", lng: "90.7000" },
      { id: 8, city: "Darrang", lat: "26.5114", lng: "92.9332" },
      { id: 9, city: "Dhemaji", lat: "27.5700", lng: "94.5800" },
      { id: 10, city: "Dhubri", lat: "26.0200", lng: "89.9700" },
      { id: 11, city: "Dibrugarh", lat: "27.4728", lng: "94.9120" },
      { id: 12, city: "Dima Hasao", lat: "25.5000", lng: "93.0200" },
      { id: 13, city: "Goalpara", lat: "26.1700", lng: "90.6200" },
      { id: 14, city: "Golaghat", lat: "26.5100", lng: "93.9600" },
      { id: 15, city: "Hailakandi", lat: "24.6900", lng: "92.5600" },
      { id: 16, city: "Hojai", lat: "26.0000", lng: "92.8500" },
      { id: 17, city: "Jorhat", lat: "26.7500", lng: "94.2167" },
      { id: 18, city: "Kamrup", lat: "26.1300", lng: "91.6200" },
      { id: 19, city: "Kamrup Metropolitan", lat: "26.1445", lng: "91.7362" },
      { id: 20, city: "Karbi Anglong", lat: "26.0000", lng: "93.4300" },
      { id: 21, city: "Karimganj", lat: "24.8700", lng: "92.3500" },
      { id: 22, city: "Kokrajhar", lat: "26.4000", lng: "90.2700" },
      { id: 23, city: "Lakhimpur", lat: "27.1300", lng: "94.1000" },
      { id: 24, city: "Majuli", lat: "27.0000", lng: "94.2000" },
      { id: 25, city: "Morigaon", lat: "26.3700", lng: "92.3400" },
      { id: 26, city: "Nagaon", lat: "26.3500", lng: "92.6800" },
      { id: 27, city: "Nalbari", lat: "26.4500", lng: "91.4400" },
      { id: 28, city: "Sivasagar", lat: "26.9800", lng: "94.6300" },
      { id: 29, city: "Sonitpur", lat: "26.7400", lng: "92.7900" },
      { id: 30, city: "South Salmara-Mankachar", lat: "25.8500", lng: "89.8600" },
      { id: 31, city: "Tinsukia", lat: "27.5000", lng: "95.3600" },
      { id: 32, city: "Udalguri", lat: "26.7700", lng: "92.1000" },
      { id: 33, city: "West Karbi Anglong", lat: "25.9400", lng: "92.8200" },
      { id: 34, city: "Tamulpur", lat: "26.5800", lng: "91.4300" },
      { id: 35, city: "Bajali", lat: "26.4900", lng: "91.2900" },
    ],
  },
  {
    id: 4,
    label: "Bihar",
    district: [
      { id: 1, city: "Araria", lat: "26.1500", lng: "87.5167" },
      { id: 2, city: "Arwal", lat: "25.2500", lng: "84.6833" },
      { id: 3, city: "Aurangabad", lat: "24.7500", lng: "84.3700" },
      { id: 4, city: "Banka", lat: "24.7833", lng: "86.9167" },
      { id: 5, city: "Begusarai", lat: "25.4167", lng: "86.1333" },
      { id: 6, city: "Bhagalpur", lat: "25.2500", lng: "87.0167" },
      { id: 7, city: "Bhojpur", lat: "25.5667", lng: "84.4000" },
      { id: 8, city: "Buxar", lat: "25.5667", lng: "83.9833" },
      { id: 9, city: "Darbhanga", lat: "26.1500", lng: "85.9000" },
      { id: 10, city: "East Champaran", lat: "26.5833", lng: "84.8333" },
      { id: 11, city: "Gaya", lat: "24.7833", lng: "85.0000" },
      { id: 12, city: "Gopalganj", lat: "26.4600", lng: "84.4300" },
      { id: 13, city: "Jamui", lat: "24.9200", lng: "86.2200" },
      { id: 14, city: "Jehanabad", lat: "25.2200", lng: "84.9800" },
      { id: 15, city: "Kaimur", lat: "25.5500", lng: "83.5833" },
      { id: 16, city: "Katihar", lat: "25.5333", lng: "87.5833" },
      { id: 17, city: "Khagaria", lat: "25.5000", lng: "86.5000" },
      { id: 18, city: "Kishanganj", lat: "26.1000", lng: "87.9500" },
      { id: 19, city: "Lakhisarai", lat: "25.1833", lng: "86.1000" },
      { id: 20, city: "Madhepura", lat: "25.9167", lng: "86.3500" },
      { id: 21, city: "Madhubani", lat: "26.3500", lng: "86.0667" },
      { id: 22, city: "Munger", lat: "25.3800", lng: "86.4700" },
      { id: 23, city: "Muzaffarpur", lat: "26.1225", lng: "85.3906" },
      { id: 24, city: "Nalanda", lat: "25.1333", lng: "85.4500" },
      { id: 25, city: "Nawada", lat: "24.8833", lng: "85.5333" },
      { id: 26, city: "Patna", lat: "25.6000", lng: "85.1000" },
      { id: 27, city: "Purnia", lat: "25.7800", lng: "87.4700" },
      { id: 28, city: "Rohtas", lat: "24.9500", lng: "84.0200" },
      { id: 29, city: "Saharsa", lat: "25.8800", lng: "86.6000" },
      { id: 30, city: "Samastipur", lat: "25.8600", lng: "85.7800" },
      { id: 31, city: "Saran", lat: "25.8700", lng: "84.6200" },
      { id: 32, city: "Sheikhpura", lat: "25.1400", lng: "85.8500" },
      { id: 33, city: "Sheohar", lat: "26.5100", lng: "85.3000" },
      { id: 34, city: "Sitamarhi", lat: "26.6000", lng: "85.5000" },
      { id: 35, city: "Siwan", lat: "26.2300", lng: "84.3600" },
      { id: 36, city: "Supaul", lat: "26.1300", lng: "86.6000" },
      { id: 37, city: "Vaishali", lat: "25.6900", lng: "85.2200" },
      { id: 38, city: "West Champaran", lat: "27.1300", lng: "84.3500" },
    ],
  },
  {
    id: 5,
    label: "Chhattisgarh",
    district: [
      { id: 1, city: "Balod", lat: "20.7300", lng: "81.2000" },
      { id: 2, city: "Baloda Bazar", lat: "21.6557", lng: "82.1609" },
      { id: 3, city: "Balrampur", lat: "23.6000", lng: "83.6000" },
      { id: 4, city: "Bastar", lat: "19.1000", lng: "81.9600" },
      { id: 5, city: "Bemetara", lat: "21.7000", lng: "81.5300" },
      { id: 6, city: "Bijapur", lat: "18.8000", lng: "80.8333" },
      { id: 7, city: "Bilaspur", lat: "22.0900", lng: "82.1500" },
      { id: 8, city: "Dantewada", lat: "18.9000", lng: "81.3500" },
      { id: 9, city: "Dhamtari", lat: "20.7000", lng: "81.5500" },
      { id: 10, city: "Durg", lat: "21.1900", lng: "81.2800" },
      { id: 11, city: "Gariaband", lat: "20.6333", lng: "82.0667" },
      { id: 12, city: "Gaurela-Pendra-Marwahi", lat: "22.7667", lng: "81.9000" },
      { id: 13, city: "Janjgir-Champa", lat: "21.9333", lng: "82.5670" },
      { id: 14, city: "Jashpur", lat: "22.9000", lng: "84.1500" },
      { id: 15, city: "Kanker", lat: "20.2700", lng: "81.4900" },
      { id: 16, city: "Kabirdham", lat: "22.0000", lng: "81.2500" },
      { id: 17, city: "Kondagaon", lat: "19.5900", lng: "81.6700" },
      { id: 18, city: "Korba", lat: "22.3500", lng: "82.6800" },
      { id: 19, city: "Koriya", lat: "23.2000", lng: "82.6500" },
      { id: 20, city: "Mahasamund", lat: "21.1100", lng: "82.1000" },
      { id: 21, city: "Mungeli", lat: "22.0700", lng: "81.6800" },
      { id: 22, city: "Narayanpur", lat: "19.7300", lng: "81.2500" },
      { id: 23, city: "Raigarh", lat: "21.9000", lng: "83.4000" },
      { id: 24, city: "Raipur", lat: "21.2500", lng: "81.6300" },
      { id: 25, city: "Rajnandgaon", lat: "21.1000", lng: "81.0300" },
      { id: 26, city: "Sarangarh-Bilaigarh", lat: "21.6100", lng: "83.0500" },
      { id: 27, city: "Sukma", lat: "18.4000", lng: "81.8500" },
      { id: 28, city: "Surajpur", lat: "23.2200", lng: "83.1200" },
      { id: 29, city: "Surguja", lat: "23.1200", lng: "83.2000" },
      { id: 30, city: "Manendragarh-Chirmiri-Bharatpur", lat: "23.2000", lng: "82.3000" },
      { id: 31, city: "Mohla-Manpur-Ambagarh Chowki", lat: "20.7800", lng: "80.9400" },
      { id: 32, city: "Sakti", lat: "22.0300", lng: "82.9700" },
      { id: 33, city: "Khairagarh-Chhuikhadan-Gandai", lat: "21.4300", lng: "80.9700" },
    ],
  },
  {
    id: 6,
    label: "Goa",
    district: [
      { id: 1, city: "North Goa", lat: "15.5557", lng: "73.8178" },
      { id: 2, city: "South Goa", lat: "15.1600", lng: "74.0200" },
      { id: 3, city: "Panaji", lat: "15.4909", lng: "73.8278" },
    ],
  },
  {
    id: 7,
    label: "Gujarat",
    district: [
      { id: 1, city: "Ahmedabad", lat: "23.0225", lng: "72.5714" },
      { id: 2, city: "Amreli", lat: "21.6000", lng: "71.2167" },
      { id: 3, city: "Anand", lat: "22.5645", lng: "72.9289" },
      { id: 4, city: "Aravalli", lat: "23.6000", lng: "73.0000" },
      { id: 5, city: "Banaskantha", lat: "24.1725", lng: "72.3446" },
      { id: 6, city: "Bharuch", lat: "21.7051", lng: "72.9959" },
      { id: 7, city: "Bhavnagar", lat: "21.7645", lng: "72.1519" },
      { id: 8, city: "Botad", lat: "22.1700", lng: "71.6673" },
      { id: 9, city: "Chhota Udaipur", lat: "22.3125", lng: "74.0089" },
      { id: 10, city: "Dahod", lat: "22.8333", lng: "74.2500" },
      { id: 11, city: "Dang", lat: "20.7500", lng: "73.5000" },
      { id: 12, city: "Devbhoomi Dwarka", lat: "22.2403", lng: "69.0700" },
      { id: 13, city: "Gandhinagar", lat: "23.2230", lng: "72.6500" },
      { id: 14, city: "Gir Somnath", lat: "20.8833", lng: "70.4000" },
      { id: 15, city: "Jamnagar", lat: "22.4707", lng: "70.0577" },
      { id: 16, city: "Junagadh", lat: "21.5222", lng: "70.4579" },
      { id: 17, city: "Kheda", lat: "22.7500", lng: "72.6800" },
      { id: 18, city: "Kutch", lat: "23.2500", lng: "69.6700" },
      { id: 19, city: "Mahisagar", lat: "22.8333", lng: "73.5833" },
      { id: 20, city: "Mehsana", lat: "23.6000", lng: "72.4000" },
      { id: 21, city: "Morbi", lat: "22.8173", lng: "70.8370" },
      { id: 22, city: "Narmada", lat: "21.6200", lng: "73.5000" },
      { id: 23, city: "Navsari", lat: "20.8500", lng: "72.9200" },
      { id: 24, city: "Panchmahal", lat: "22.8300", lng: "73.6000" },
      { id: 25, city: "Patan", lat: "23.8500", lng: "72.1200" },
      { id: 26, city: "Porbandar", lat: "21.6400", lng: "69.6000" },
      { id: 27, city: "Rajkot", lat: "22.3000", lng: "70.7833" },
      { id: 28, city: "Sabarkantha", lat: "23.8500", lng: "73.0000" },
      { id: 29, city: "Surat", lat: "21.1702", lng: "72.8311" },
      { id: 30, city: "Surendranagar", lat: "22.7206", lng: "71.6409" },
      { id: 31, city: "Tapi", lat: "21.1500", lng: "73.5000" },
      { id: 32, city: "Vadodara", lat: "22.3072", lng: "73.1812" },
      { id: 33, city: "Valsad", lat: "20.6100", lng: "72.9300" },
    ],
  },
  {
    id: 8,
    label: "Haryana",
    district: [
      { id: 1, city: "Ambala", lat: "30.3782", lng: "76.7767" },
      { id: 2, city: "Bhiwani", lat: "28.7911", lng: "76.1410" },
      { id: 3, city: "Charkhi Dadri", lat: "28.5910", lng: "76.2670" },
      { id: 4, city: "Faridabad", lat: "28.4089", lng: "77.3178" },
      { id: 5, city: "Fatehabad", lat: "29.5163", lng: "75.4550" },
      { id: 6, city: "Gurugram", lat: "28.4595", lng: "77.0266" },
      { id: 7, city: "Hisar", lat: "29.1492", lng: "75.7217" },
      { id: 8, city: "Jhajjar", lat: "28.6100", lng: "76.6500" },
      { id: 9, city: "Jind", lat: "29.3167", lng: "76.3167" },
      { id: 10, city: "Kaithal", lat: "29.8000", lng: "76.3833" },
      { id: 11, city: "Karnal", lat: "29.6857", lng: "76.9905" },
      { id: 12, city: "Kurukshetra", lat: "29.9695", lng: "76.8783" },
      { id: 13, city: "Mahendragarh", lat: "28.2833", lng: "76.1500" },
      { id: 14, city: "Nuh", lat: "28.1000", lng: "77.0000" },
      { id: 15, city: "Palwal", lat: "28.1500", lng: "77.3333" },
      { id: 16, city: "Panchkula", lat: "30.6942", lng: "76.8606" },
      { id: 17, city: "Panipat", lat: "29.3909", lng: "76.9635" },
      { id: 18, city: "Rewari", lat: "28.1833", lng: "76.6167" },
      { id: 19, city: "Rohtak", lat: "28.9000", lng: "76.5667" },
      { id: 20, city: "Sirsa", lat: "29.5333", lng: "75.0167" },
      { id: 21, city: "Sonipat", lat: "28.9959", lng: "77.0114" },
      { id: 22, city: "Yamunanagar", lat: "30.1290", lng: "77.2670" },
    ],
  },
  {
    id: 9,
    label: "Himachal Pradesh",
    district: [
      { id: 1, city: "Bilaspur", lat: "31.3322", lng: "76.7550" },
      { id: 2, city: "Chamba", lat: "32.5567", lng: "76.1255" },
      { id: 3, city: "Hamirpur", lat: "31.6841", lng: "76.5255" },
      { id: 4, city: "Kangra", lat: "32.1024", lng: "76.2691" },
      { id: 5, city: "Kinnaur", lat: "31.5833", lng: "78.2500" },
      { id: 6, city: "Kullu", lat: "31.9575", lng: "77.1095" },
      { id: 7, city: "Lahaul and Spiti", lat: "32.5700", lng: "77.5800" },
      { id: 8, city: "Mandi", lat: "31.7075", lng: "76.9294" },
      { id: 9, city: "Shimla", lat: "31.1048", lng: "77.1734" },
      { id: 10, city: "Sirmaur", lat: "30.8400", lng: "77.7500" },
      { id: 11, city: "Solan", lat: "30.9050", lng: "77.0968" },
      { id: 12, city: "Una", lat: "31.4649", lng: "76.2708" },
    ],
  },
  {
    id: 10,
    label: "Jharkhand",
    district: [
      { id: 1, city: "Bokaro", lat: "23.6693", lng: "86.1511" },
      { id: 2, city: "Chatra", lat: "24.2064", lng: "84.8700" },
      { id: 3, city: "Deoghar", lat: "24.4820", lng: "86.6990" },
      { id: 4, city: "Dhanbad", lat: "23.7957", lng: "86.4304" },
      { id: 5, city: "Dumka", lat: "24.2689", lng: "87.2452" },
      { id: 6, city: "East Singhbhum", lat: "22.8000", lng: "86.2000" },
      { id: 7, city: "Garhwa", lat: "24.1833", lng: "83.8167" },
      { id: 8, city: "Giridih", lat: "24.1800", lng: "86.3000" },
      { id: 9, city: "Godda", lat: "24.8300", lng: "87.2100" },
      { id: 10, city: "Gumla", lat: "23.0500", lng: "84.5400" },
      { id: 11, city: "Hazaribagh", lat: "23.9800", lng: "85.3600" },
      { id: 12, city: "Jamtara", lat: "23.9500", lng: "86.8000" },
      { id: 13, city: "Khunti", lat: "23.0833", lng: "85.2833" },
      { id: 14, city: "Koderma", lat: "24.4670", lng: "85.5934" },
      { id: 15, city: "Latehar", lat: "23.7500", lng: "84.5000" },
      { id: 16, city: "Lohardaga", lat: "23.4333", lng: "84.6833" },
      { id: 17, city: "Pakur", lat: "24.6400", lng: "87.8500" },
      { id: 18, city: "Palamu", lat: "24.0800", lng: "84.0700" },
      { id: 19, city: "Ramgarh", lat: "23.6400", lng: "85.5100" },
      { id: 20, city: "Ranchi", lat: "23.3441", lng: "85.3096" },
      { id: 21, city: "Sahebganj", lat: "25.2400", lng: "87.6300" },
      { id: 22, city: "Seraikela-Kharsawan", lat: "22.7000", lng: "85.9800" },
      { id: 23, city: "Simdega", lat: "22.6200", lng: "84.5200" },
      { id: 24, city: "West Singhbhum", lat: "22.5500", lng: "85.8000" },
    ],
  },
  {
    id: 11,
    label: "Karnataka",
    district: [
      { id: 1, city: "Bagalkot", lat: "16.1800", lng: "75.7000" },
      { id: 2, city: "Ballari", lat: "15.1500", lng: "76.9200" },
      { id: 3, city: "Belagavi", lat: "15.8500", lng: "74.5000" },
      { id: 4, city: "Bengaluru Rural", lat: "13.2000", lng: "77.7100" },
      { id: 5, city: "Bengaluru Urban", lat: "12.9716", lng: "77.5946" },
      { id: 6, city: "Bidar", lat: "17.9133", lng: "77.5301" },
      { id: 7, city: "Chamarajanagar", lat: "11.9260", lng: "76.9394" },
      { id: 8, city: "Chikballapur", lat: "13.4350", lng: "77.7315" },
      { id: 9, city: "Chikkamagaluru", lat: "13.3203", lng: "75.7721" },
      { id: 10, city: "Chitradurga", lat: "14.2300", lng: "76.4000" },
      { id: 11, city: "Dakshina Kannada", lat: "12.8700", lng: "74.8800" },
      { id: 12, city: "Davanagere", lat: "14.4700", lng: "75.9200" },
      { id: 13, city: "Dharwad", lat: "15.4600", lng: "75.0000" },
      { id: 14, city: "Gadag", lat: "15.4333", lng: "75.6333" },
      { id: 15, city: "Hassan", lat: "13.0000", lng: "76.1000" },
      { id: 16, city: "Haveri", lat: "14.7936", lng: "75.4039" },
      { id: 17, city: "Kalaburagi", lat: "17.3297", lng: "76.8343" },
      { id: 18, city: "Kodagu", lat: "12.4220", lng: "75.7390" },
      { id: 19, city: "Kolar", lat: "13.1339", lng: "78.1294" },
      { id: 20, city: "Koppal", lat: "15.3500", lng: "76.1500" },
      { id: 21, city: "Mandya", lat: "12.5200", lng: "76.9000" },
      { id: 22, city: "Mysuru", lat: "12.2958", lng: "76.6394" },
      { id: 23, city: "Raichur", lat: "16.2000", lng: "77.3667" },
      { id: 24, city: "Ramanagara", lat: "12.7167", lng: "77.3000" },
      { id: 25, city: "Shivamogga", lat: "13.9299", lng: "75.5681" },
      { id: 26, city: "Tumakuru", lat: "13.3409", lng: "77.1010" },
      { id: 27, city: "Udupi", lat: "13.3409", lng: "74.7421" },
      { id: 28, city: "Uttara Kannada", lat: "14.8000", lng: "74.1300" },
      { id: 29, city: "Vijayapura", lat: "16.8300", lng: "75.7100" },
      { id: 30, city: "Yadgir", lat: "16.7700", lng: "77.1400" },
      { id: 31, city: "Vijayanagara", lat: "15.5800", lng: "76.5300" },
    ],
  },
  {
    id: 12,
    label: "Kerala",
    district: [
      { id: 1, city: "Alappuzha", lat: "9.4981", lng: "76.3388" },
      { id: 2, city: "Ernakulam", lat: "9.9816", lng: "76.2999" },
      { id: 3, city: "Idukki", lat: "9.8500", lng: "77.1000" },
      { id: 4, city: "Kannur", lat: "11.8745", lng: "75.3704" },
      { id: 5, city: "Kasaragod", lat: "12.5000", lng: "75.0000" },
      { id: 6, city: "Kollam", lat: "8.8932", lng: "76.6141" },
      { id: 7, city: "Kottayam", lat: "9.5916", lng: "76.5222" },
      { id: 8, city: "Kozhikode", lat: "11.2588", lng: "75.7804" },
      { id: 9, city: "Malappuram", lat: "11.0667", lng: "76.0667" },
      { id: 10, city: "Palakkad", lat: "10.7867", lng: "76.6548" },
      { id: 11, city: "Pathanamthitta", lat: "9.2647", lng: "76.7870" },
      { id: 12, city: "Thiruvananthapuram", lat: "8.5241", lng: "76.9366" },
      { id: 13, city: "Thrissur", lat: "10.5276", lng: "76.2144" },
      { id: 14, city: "Wayanad", lat: "11.6854", lng: "76.1320" },
    ],
  },
  {
    id: 13,
    label: "Madhya Pradesh",
    district: [
      { id: 1, city: "Agar Malwa", lat: "23.7085", lng: "76.0163" },
      { id: 2, city: "Alirajpur", lat: "22.3110", lng: "74.3556" },
      { id: 3, city: "Anuppur", lat: "23.1036", lng: "81.6833" },
      { id: 4, city: "Ashoknagar", lat: "24.5740", lng: "77.7306" },
      { id: 5, city: "Balaghat", lat: "21.8129", lng: "80.1840" },
      { id: 6, city: "Barwani", lat: "22.0328", lng: "74.8984" },
      { id: 7, city: "Betul", lat: "21.9100", lng: "77.9200" },
      { id: 8, city: "Bhind", lat: "26.5667", lng: "78.8000" },
      { id: 9, city: "Bhopal", lat: "23.2599", lng: "77.4126" },
      { id: 10, city: "Burhanpur", lat: "21.3000", lng: "76.2300" },
      { id: 11, city: "Chhatarpur", lat: "24.9000", lng: "79.6000" },
      { id: 12, city: "Chhindwara", lat: "22.0574", lng: "78.9382" },
      { id: 13, city: "Damoh", lat: "23.8361", lng: "79.4417" },
      { id: 14, city: "Datia", lat: "25.6700", lng: "78.4600" },
      { id: 15, city: "Dewas", lat: "22.9600", lng: "76.0600" },
      { id: 16, city: "Dhar", lat: "22.6000", lng: "75.3000" },
      { id: 17, city: "Dindori", lat: "22.9333", lng: "81.0833" },
      { id: 18, city: "Guna", lat: "24.6500", lng: "77.3200" },
      { id: 19, city: "Gwalior", lat: "26.2183", lng: "78.1828" },
      { id: 20, city: "Harda", lat: "22.3300", lng: "77.1000" },
      { id: 21, city: "Hoshangabad", lat: "22.7500", lng: "77.7200" },
      { id: 22, city: "Indore", lat: "22.7196", lng: "75.8577" },
      { id: 23, city: "Jabalpur", lat: "23.1815", lng: "79.9864" },
      { id: 24, city: "Jhabua", lat: "22.7674", lng: "74.6029" },
      { id: 25, city: "Katni", lat: "23.8340", lng: "80.3930" },
      { id: 26, city: "Khandwa", lat: "21.8335", lng: "76.3507" },
      { id: 27, city: "Khargone", lat: "21.8333", lng: "75.6167" },
      { id: 28, city: "Mandla", lat: "22.6000", lng: "80.3833" },
      { id: 29, city: "Mandsaur", lat: "24.0700", lng: "75.0700" },
      { id: 30, city: "Morena", lat: "26.5000", lng: "78.0000" },
      { id: 31, city: "Narsinghpur", lat: "22.9500", lng: "79.2000" },
      { id: 32, city: "Neemuch", lat: "24.4700", lng: "74.8700" },
      { id: 33, city: "Niwari", lat: "25.6333", lng: "78.7500" },
      { id: 34, city: "Panna", lat: "24.7200", lng: "80.1900" },
      { id: 35, city: "Raisen", lat: "23.3300", lng: "77.8000" },
      { id: 36, city: "Rajgarh", lat: "23.8667", lng: "76.7333" },
      { id: 37, city: "Ratlam", lat: "23.3167", lng: "75.0667" },
      { id: 38, city: "Rewa", lat: "24.5300", lng: "81.3000" },
      { id: 39, city: "Sagar", lat: "23.8300", lng: "78.7100" },
      { id: 40, city: "Satna", lat: "24.6000", lng: "80.8300" },
      { id: 41, city: "Sehore", lat: "23.2000", lng: "77.0800" },
      { id: 42, city: "Seoni", lat: "22.0833", lng: "79.5500" },
      { id: 43, city: "Shahdol", lat: "23.3000", lng: "81.3500" },
      { id: 44, city: "Shajapur", lat: "23.4333", lng: "76.2667" },
      { id: 45, city: "Sheopur", lat: "25.6700", lng: "76.7000" },
      { id: 46, city: "Shivpuri", lat: "25.4230", lng: "77.6620" },
      { id: 47, city: "Sidhi", lat: "24.4167", lng: "81.8833" },
      { id: 48, city: "Singrauli", lat: "24.1990", lng: "82.6750" },
      { id: 49, city: "Tikamgarh", lat: "24.7500", lng: "78.8300" },
      { id: 50, city: "Ujjain", lat: "23.1793", lng: "75.7849" },
      { id: 51, city: "Umaria", lat: "23.5240", lng: "80.8373" },
      { id: 52, city: "Vidisha", lat: "23.5245", lng: "77.8062" },
    ],
  },
  {
    id: 14,
    label: "Maharashtra",
    district: [
      { id: 1, city: "Mumbai City", lat: "19.0761", lng: "72.8775" },
      { id: 2, city: "Mumbai Suburban", lat: "19.0330", lng: "73.0297" },
      { id: 3, city: "Thane", lat: "19.2183", lng: "72.9781" },
      { id: 4, city: "Palghar", lat: "19.6967", lng: "72.7658" },
      { id: 5, city: "Raigad", lat: "18.5074", lng: "73.0150" },
      { id: 6, city: "Ratnagiri", lat: "16.9944", lng: "73.3000" },
      { id: 7, city: "Sindhudurg", lat: "16.2667", lng: "73.5000" },
      { id: 8, city: "Pune", lat: "18.5203", lng: "73.8567" },
      { id: 9, city: "Nashik", lat: "19.9975", lng: "73.7898" },
      { id: 10, city: "Ahmednagar", lat: "19.0948", lng: "74.7480" },
      { id: 11, city: "Solapur", lat: "17.6599", lng: "75.9064" },
      { id: 12, city: "Satara", lat: "17.6599", lng: "74.0120" },
      { id: 13, city: "Sangli", lat: "16.8524", lng: "74.5815" },
      { id: 14, city: "Kolhapur", lat: "16.7050", lng: "74.2433" },
      { id: 15, city: "Aurangabad", lat: "19.8762", lng: "75.3433" },
      { id: 16, city: "Jalna", lat: "19.8347", lng: "75.8861" },
      { id: 17, city: "Parbhani", lat: "19.2608", lng: "76.7734" },
      { id: 18, city: "Hingoli", lat: "19.7147", lng: "77.1641" },
      { id: 19, city: "Beed", lat: "18.9890", lng: "75.7613" },
      { id: 20, city: "Osmanabad", lat: "18.1760", lng: "76.0392" },
      { id: 21, city: "Latur", lat: "18.4088", lng: "76.5604" },
      { id: 22, city: "Nanded", lat: "19.1383", lng: "77.3210" },
      { id: 23, city: "Dhule", lat: "20.9042", lng: "74.7749" },
      { id: 24, city: "Jalgaon", lat: "21.0077", lng: "75.5626" },
      { id: 25, city: "Nandurbar", lat: "21.3724", lng: "74.2479" },
      { id: 26, city: "Nagpur", lat: "21.1458", lng: "79.0882" },
      { id: 27, city: "Wardha", lat: "20.7453", lng: "78.5957" },
      { id: 28, city: "Bhandara", lat: "21.1704", lng: "79.6552" },
      { id: 29, city: "Gondia", lat: "21.4584", lng: "80.1964" },
      { id: 30, city: "Chandrapur", lat: "19.9615", lng: "79.2961" },
      { id: 31, city: "Gadchiroli", lat: "20.1809", lng: "80.0056" },
      { id: 32, city: "Amravati", lat: "20.9319", lng: "77.7523" },
      { id: 33, city: "Akola", lat: "20.7002", lng: "77.0082" },
      { id: 34, city: "Washim", lat: "20.1086", lng: "77.1331" },
      { id: 35, city: "Buldhana", lat: "20.5307", lng: "76.1815" },
      { id: 36, city: "Yavatmal", lat: "20.3897", lng: "78.1307" },
    ],
  },
  {
    id: 15,
    label: "Manipur",
    district: [
      { id: 1, city: "Bishnupur", lat: "24.5833", lng: "93.7500" },
      { id: 2, city: "Chandel", lat: "24.3000", lng: "94.0000" },
      { id: 3, city: "Churachandpur", lat: "24.3333", lng: "93.6667" },
      { id: 4, city: "Imphal East", lat: "24.8167", lng: "93.9667" },
      { id: 5, city: "Imphal West", lat: "24.8167", lng: "93.9333" },
      { id: 6, city: "Jiribam", lat: "24.8000", lng: "93.1333" },
      { id: 7, city: "Kakching", lat: "24.4843", lng: "93.9826" },
      { id: 8, city: "Kamjong", lat: "25.0543", lng: "94.4677" },
      { id: 9, city: "Kangpokpi", lat: "25.1588", lng: "94.0144" },
      { id: 10, city: "Noney", lat: "24.7520", lng: "93.5010" },
      { id: 11, city: "Pherzawl", lat: "24.2833", lng: "93.4833" },
      { id: 12, city: "Senapati", lat: "25.2667", lng: "94.1167" },
      { id: 13, city: "Tamenglong", lat: "25.0000", lng: "93.5000" },
      { id: 14, city: "Tengnoupal", lat: "24.2100", lng: "94.2000" },
      { id: 15, city: "Thoubal", lat: "24.6400", lng: "94.0200" },
      { id: 16, city: "Ukhrul", lat: "25.1167", lng: "94.3667" },
    ],
  },
  {
    id: 16,
    label: "Meghalaya",
    district: [
      { id: 1, city: "East Garo Hills", lat: "25.5700", lng: "90.6200" },
      { id: 2, city: "East Jaintia Hills", lat: "25.4500", lng: "92.3000" },
      { id: 3, city: "East Khasi Hills", lat: "25.5760", lng: "91.8820" },
      { id: 4, city: "North Garo Hills", lat: "25.9793", lng: "90.5245" },
      { id: 5, city: "Ri-Bhoi", lat: "25.9025", lng: "91.8789" },
      { id: 6, city: "South Garo Hills", lat: "25.3400", lng: "90.6333" },
      { id: 7, city: "South West Garo Hills", lat: "25.4200", lng: "90.2333" },
      { id: 8, city: "South West Khasi Hills", lat: "25.3833", lng: "91.2833" },
      { id: 9, city: "West Garo Hills", lat: "25.5100", lng: "90.2200" },
      { id: 10, city: "West Jaintia Hills", lat: "25.5000", lng: "92.0000" },
      { id: 11, city: "West Khasi Hills", lat: "25.5667", lng: "91.2667" },
      { id: 12, city: "Eastern West Khasi Hills", lat: "25.6111", lng: "91.2125" },
    ],
  },
  {
    id: 17,
    label: "Mizoram",
    district: [
      { id: 1, city: "Aizawl", lat: "23.7271", lng: "92.7176" },
      { id: 2, city: "Champhai", lat: "23.4700", lng: "93.3300" },
      { id: 3, city: "Kolasib", lat: "24.2200", lng: "92.6800" },
      { id: 4, city: "Lawngtlai", lat: "22.5000", lng: "92.9000" },
      { id: 5, city: "Lunglei", lat: "22.8800", lng: "92.7300" },
      { id: 6, city: "Mamit", lat: "23.9300", lng: "92.4800" },
      { id: 7, city: "Saiha", lat: "22.4833", lng: "92.9833" },
      { id: 8, city: "Serchhip", lat: "23.3000", lng: "92.8333" },
      { id: 9, city: "Hnahthial", lat: "22.8167", lng: "92.9167" },
      { id: 10, city: "Khawzawl", lat: "23.1833", lng: "93.1333" },
      { id: 11, city: "Saitual", lat: "23.6667", lng: "92.8667" },
    ],
  },
  {
    id: 18,
    label: "Nagaland",
    district: [
      { id: 1, city: "Chümoukedima", lat: "25.7390", lng: "93.7308" },
      { id: 2, city: "Dimapur", lat: "25.9069", lng: "93.7259" },
      { id: 3, city: "Kiphire", lat: "25.8700", lng: "94.7700" },
      { id: 4, city: "Kohima", lat: "25.6751", lng: "94.1086" },
      { id: 5, city: "Longleng", lat: "26.5000", lng: "94.8000" },
      { id: 6, city: "Mokokchung", lat: "26.3300", lng: "94.5300" },
      { id: 7, city: "Mon", lat: "26.7500", lng: "95.1000" },
      { id: 8, city: "Niuland", lat: "26.0167", lng: "93.6833" },
      { id: 9, city: "Noklak", lat: "26.1333", lng: "94.9500" },
      { id: 10, city: "Peren", lat: "25.5500", lng: "93.6833" },
      { id: 11, city: "Phek", lat: "25.7000", lng: "94.5000" },
      { id: 12, city: "Shamator", lat: "26.2000", lng: "95.0167" },
      { id: 13, city: "Tseminyü", lat: "26.1000", lng: "94.3167" },
      { id: 14, city: "Tuensang", lat: "26.2700", lng: "94.8300" },
      { id: 15, city: "Wokha", lat: "26.0900", lng: "94.2700" },
      { id: 16, city: "Zünheboto", lat: "26.0000", lng: "94.5300" },
    ],
  },
  {
    id: 19,
    label: "Odisha",
    district: [
      { id: 1, city: "Angul", lat: "20.8372", lng: "85.0977" },
      { id: 2, city: "Balangir", lat: "20.7110", lng: "83.4923" },
      { id: 3, city: "Balasore", lat: "21.4927", lng: "86.9335" },
      { id: 4, city: "Bargarh", lat: "21.3337", lng: "83.6222" },
      { id: 5, city: "Bhadrak", lat: "21.0574", lng: "86.5020" },
      { id: 6, city: "Boudh", lat: "20.8374", lng: "84.3166" },
      { id: 7, city: "Cuttack", lat: "20.4625", lng: "85.8828" },
      { id: 8, city: "Deogarh", lat: "21.5463", lng: "84.7336" },
      { id: 9, city: "Dhenkanal", lat: "20.6500", lng: "85.6000" },
      { id: 10, city: "Gajapati", lat: "18.8167", lng: "84.1000" },
      { id: 11, city: "Ganjam", lat: "19.3752", lng: "84.6615" },
      { id: 12, city: "Jagatsinghpur", lat: "20.2653", lng: "86.1714" },
      { id: 13, city: "Jajpur", lat: "20.8500", lng: "86.3333" },
      { id: 14, city: "Jharsuguda", lat: "21.8500", lng: "84.0167" },
      { id: 15, city: "Kalahandi", lat: "19.9000", lng: "83.1667" },
      { id: 16, city: "Kandhamal", lat: "20.2167", lng: "84.2500" },
      { id: 17, city: "Kendrapara", lat: "20.5000", lng: "86.4200" },
      { id: 18, city: "Kendujhar", lat: "21.6333", lng: "85.5833" },
      { id: 19, city: "Khordha", lat: "20.1800", lng: "85.6167" },
      { id: 20, city: "Koraput", lat: "18.8135", lng: "82.7100" },
      { id: 21, city: "Malkangiri", lat: "18.3667", lng: "81.9000" },
      { id: 22, city: "Mayurbhanj", lat: "21.9333", lng: "86.7500" },
      { id: 23, city: "Nabarangpur", lat: "19.2333", lng: "82.5500" },
      { id: 24, city: "Nayagarh", lat: "20.1289", lng: "85.0964" },
      { id: 25, city: "Nuapada", lat: "20.5000", lng: "82.5500" },
      { id: 26, city: "Puri", lat: "19.8106", lng: "85.8312" },
      { id: 27, city: "Rayagada", lat: "19.1700", lng: "83.4200" },
      { id: 28, city: "Sambalpur", lat: "21.4700", lng: "83.9800" },
      { id: 29, city: "Subarnapur", lat: "20.8500", lng: "83.9167" },
      { id: 30, city: "Sundargarh", lat: "22.1200", lng: "84.0300" },
    ],
  },
  {
    id: 20,
    label: "Punjab",
    district: [
      { id: 1, city: "Amritsar", lat: "31.6340", lng: "74.8723" },
      { id: 2, city: "Barnala", lat: "30.3752", lng: "75.5489" },
      { id: 3, city: "Bathinda", lat: "30.2110", lng: "74.9455" },
      { id: 4, city: "Faridkot", lat: "30.6786", lng: "74.7585" },
      { id: 5, city: "Fatehgarh Sahib", lat: "30.6479", lng: "76.3960" },
      { id: 6, city: "Fazilka", lat: "30.4032", lng: "74.0286" },
      { id: 7, city: "Ferozepur", lat: "30.9254", lng: "74.6131" },
      { id: 8, city: "Gurdaspur", lat: "32.0416", lng: "75.4051" },
      { id: 9, city: "Hoshiarpur", lat: "31.5324", lng: "75.9128" },
      { id: 10, city: "Jalandhar", lat: "31.3260", lng: "75.5762" },
      { id: 11, city: "Kapurthala", lat: "31.3801", lng: "75.3810" },
      { id: 12, city: "Ludhiana", lat: "30.9000", lng: "75.8573" },
      { id: 13, city: "Malerkotla", lat: "30.5300", lng: "75.8833" },
      { id: 14, city: "Mansa", lat: "29.9970", lng: "75.3937" },
      { id: 15, city: "Moga", lat: "30.8165", lng: "75.1741" },
      { id: 16, city: "Mohali", lat: "30.7046", lng: "76.7179" },
      { id: 17, city: "Muktsar", lat: "30.4760", lng: "74.5167" },
      { id: 18, city: "Nawanshahr (Shaheed Bhagat Singh Nagar)", lat: "31.1236", lng: "76.1301" },
      { id: 19, city: "Pathankot", lat: "32.2643", lng: "75.7339" },
      { id: 20, city: "Patiala", lat: "30.3398", lng: "76.3869" },
      { id: 21, city: "Rupnagar", lat: "30.9675", lng: "76.5336" },
      { id: 22, city: "Sangrur", lat: "30.2455", lng: "75.8422" },
      { id: 23, city: "Tarn Taran", lat: "31.4510", lng: "74.9272" },
    ],
  },
  {
    id: 21,
    label: "Rajasthan",
    district: [
      { id: 1, city: "Ajmer", lat: "26.4499", lng: "74.6399" },
      { id: 2, city: "Alwar", lat: "27.5530", lng: "76.6346" },
      { id: 3, city: "Anupgarh", lat: "29.1906", lng: "73.2086" },
      { id: 4, city: "Balotra", lat: "25.8330", lng: "72.2334" },
      { id: 5, city: "Banswara", lat: "23.5461", lng: "74.4330" },
      { id: 6, city: "Baran", lat: "25.1000", lng: "76.5167" },
      { id: 7, city: "Barmer", lat: "25.7500", lng: "71.4167" },
      { id: 8, city: "Beawar", lat: "26.1000", lng: "74.3167" },
      { id: 9, city: "Bharatpur", lat: "27.2173", lng: "77.4895" },
      { id: 10, city: "Bhilwara", lat: "25.3463", lng: "74.6359" },
      { id: 11, city: "Bikaner", lat: "28.0229", lng: "73.3119" },
      { id: 12, city: "Bundi", lat: "25.4381", lng: "75.6377" },
      { id: 13, city: "Chittorgarh", lat: "24.8887", lng: "74.6269" },
      { id: 14, city: "Churu", lat: "28.2966", lng: "74.9672" },
      { id: 15, city: "Dausa", lat: "26.8887", lng: "76.3190" },
      { id: 16, city: "Dholpur", lat: "26.7000", lng: "77.9000" },
      { id: 17, city: "Didwana-Kuchaman", lat: "27.4000", lng: "74.5833" },
      { id: 18, city: "Dungarpur", lat: "23.8430", lng: "73.7147" },
      { id: 19, city: "Ganganagar", lat: "29.9038", lng: "73.8772" },
      { id: 20, city: "Gangapur City", lat: "26.4725", lng: "76.7174" },
      { id: 21, city: "Hanumangarh", lat: "29.5810", lng: "74.3294" },
      { id: 22, city: "Jaipur", lat: "26.9124", lng: "75.7873" },
      { id: 23, city: "Jaisalmer", lat: "26.9157", lng: "70.9083" },
      { id: 24, city: "Jalore", lat: "25.3500", lng: "72.6167" },
      { id: 25, city: "Jhalawar", lat: "24.5964", lng: "76.1636" },
      { id: 26, city: "Jhunjhunu", lat: "28.1286", lng: "75.3993" },
      { id: 27, city: "Jodhpur", lat: "26.2389", lng: "73.0243" },
      { id: 28, city: "Karauli", lat: "26.5000", lng: "77.0167" },
      { id: 29, city: "Kekri", lat: "25.9667", lng: "75.1500" },
      { id: 30, city: "Kota", lat: "25.2138", lng: "75.8648" },
      { id: 31, city: "Kotputli-Behror", lat: "27.7167", lng: "76.2000" },
      { id: 32, city: "Nagaur", lat: "27.2020", lng: "73.7400" },
      { id: 33, city: "Neem Ka Thana", lat: "27.7400", lng: "75.7700" },
      { id: 34, city: "Pali", lat: "25.7725", lng: "73.3234" },
      { id: 35, city: "Phalodi", lat: "27.1310", lng: "72.3680" },
      { id: 36, city: "Rajsamand", lat: "25.0667", lng: "73.8833" },
      { id: 37, city: "Salumbar", lat: "24.1377", lng: "74.0502" },
      { id: 38, city: "Sanchore", lat: "24.7464", lng: "71.7727" },
      { id: 39, city: "Sawai Madhopur", lat: "26.0370", lng: "76.3562" },
      { id: 40, city: "Shahpura", lat: "27.3900", lng: "75.9500" },
      { id: 41, city: "Sikar", lat: "27.6094", lng: "75.1399" },
      { id: 42, city: "Sirohi", lat: "24.8859", lng: "72.8570" },
      { id: 43, city: "Sri Ganganagar", lat: "29.9038", lng: "73.8772" },
      { id: 44, city: "Sri Madhopur", lat: "27.4654", lng: "75.5972" },
      { id: 45, city: "Tonk", lat: "26.1667", lng: "75.7833" },
      { id: 46, city: "Udaipur", lat: "24.5854", lng: "73.7125" },
      { id: 47, city: "Jodhpur East", lat: "26.2756", lng: "73.0369" },
      { id: 48, city: "Jodhpur West", lat: "26.2645", lng: "73.0042" },
      { id: 49, city: "Bansur", lat: "27.6000", lng: "76.4000" },
      { id: 50, city: "Khairthal-Tijara", lat: "27.9500", lng: "76.7500" },
    ],
  },
  {
    id: 22,
    label: "Sikkim",
    district: [
      { id: 1, city: "Gangtok", lat: "27.3389", lng: "88.6065" },
      { id: 2, city: "Gyalshing (West Sikkim)", lat: "27.2500", lng: "88.2500" },
      { id: 3, city: "Mangan (North Sikkim)", lat: "27.5200", lng: "88.5300" },
      { id: 4, city: "Namchi (South Sikkim)", lat: "27.1667", lng: "88.3667" },
      { id: 5, city: "Pakyong", lat: "27.2189", lng: "88.6141" },
      { id: 6, city: "Soreng", lat: "27.2333", lng: "88.3000" },
    ],
  },
  {
    id: 23,
    label: "Tamil Nadu",
    district: [
      { id: 1, city: "Ariyalur", lat: "11.1390", lng: "79.0756" },
      { id: 2, city: "Chengalpattu", lat: "12.6936", lng: "79.9773" },
      { id: 3, city: "Chennai", lat: "13.0827", lng: "80.2707" },
      { id: 4, city: "Coimbatore", lat: "11.0168", lng: "76.9558" },
      { id: 5, city: "Cuddalore", lat: "11.7480", lng: "79.7714" },
      { id: 6, city: "Dharmapuri", lat: "12.1357", lng: "78.1610" },
      { id: 7, city: "Dindigul", lat: "10.3673", lng: "77.9803" },
      { id: 8, city: "Erode", lat: "11.3410", lng: "77.7172" },
      { id: 9, city: "Kallakurichi", lat: "11.7380", lng: "78.9621" },
      { id: 10, city: "Kanchipuram", lat: "12.8342", lng: "79.7036" },
      { id: 11, city: "Kanyakumari", lat: "8.0883", lng: "77.5385" },
      { id: 12, city: "Karur", lat: "10.9601", lng: "78.0766" },
      { id: 13, city: "Krishnagiri", lat: "12.5186", lng: "78.2130" },
      { id: 14, city: "Madurai", lat: "9.9252", lng: "78.1198" },
      { id: 15, city: "Mayiladuthurai", lat: "11.1000", lng: "79.6500" },
      { id: 16, city: "Nagapattinam", lat: "10.7632", lng: "79.8431" },
      { id: 17, city: "Namakkal", lat: "11.2196", lng: "78.1670" },
      { id: 18, city: "Nilgiris", lat: "11.4064", lng: "76.6932" },
      { id: 19, city: "Perambalur", lat: "11.2333", lng: "78.8667" },
      { id: 20, city: "Pudukkottai", lat: "10.3813", lng: "78.8214" },
      { id: 21, city: "Ramanathapuram", lat: "9.3700", lng: "78.8300" },
      { id: 22, city: "Ranipet", lat: "12.9264", lng: "79.3335" },
      { id: 23, city: "Salem", lat: "11.6643", lng: "78.1460" },
      { id: 24, city: "Sivaganga", lat: "9.8474", lng: "78.4836" },
      { id: 25, city: "Tenkasi", lat: "8.9600", lng: "77.3200" },
      { id: 26, city: "Thanjavur", lat: "10.7867", lng: "79.1391" },
      { id: 27, city: "Theni", lat: "10.0153", lng: "77.4820" },
      { id: 28, city: "Thoothukudi", lat: "8.7642", lng: "78.1348" },
      { id: 29, city: "Tiruchirappalli", lat: "10.7905", lng: "78.7047" },
      { id: 30, city: "Tirunelveli", lat: "8.7139", lng: "77.7567" },
      { id: 31, city: "Tirupattur", lat: "12.5000", lng: "78.5667" },
      { id: 32, city: "Tiruppur", lat: "11.1085", lng: "77.3411" },
      { id: 33, city: "Tiruvallur", lat: "13.1406", lng: "79.9042" },
      { id: 34, city: "Tiruvannamalai", lat: "12.2253", lng: "79.0747" },
      { id: 35, city: "Tiruvarur", lat: "10.7677", lng: "79.6360" },
      { id: 36, city: "Vellore", lat: "12.9165", lng: "79.1325" },
      { id: 37, city: "Viluppuram", lat: "11.7587", lng: "79.4931" },
      { id: 38, city: "Virudhunagar", lat: "9.5851", lng: "77.9579" },
    ],
  },
  {
    id: 24,
    label: "Telangana",
    district: [
      { id: 1, city: "Adilabad", lat: "19.6667", lng: "78.5333" },
      { id: 2, city: "Bhadradri Kothagudem", lat: "17.5500", lng: "80.6167" },
      { id: 3, city: "Hanumakonda", lat: "17.9970", lng: "79.5929" },
      { id: 4, city: "Hyderabad", lat: "17.3850", lng: "78.4867" },
      { id: 5, city: "Jagtial", lat: "18.7900", lng: "78.9300" },
      { id: 6, city: "Jangaon", lat: "17.7250", lng: "79.1500" },
      { id: 7, city: "Jayashankar Bhupalpally", lat: "18.4350", lng: "79.8500" },
      { id: 8, city: "Jogulamba Gadwal", lat: "16.2300", lng: "77.8000" },
      { id: 9, city: "Kamareddy", lat: "18.3250", lng: "78.3400" },
      { id: 10, city: "Karimnagar", lat: "18.4386", lng: "79.1288" },
      { id: 11, city: "Khammam", lat: "17.2473", lng: "80.1514" },
      { id: 12, city: "Komaram Bheem", lat: "19.1000", lng: "79.0000" },
      { id: 13, city: "Mahabubabad", lat: "17.6000", lng: "80.0000" },
      { id: 14, city: "Mahabubnagar", lat: "16.7480", lng: "77.9975" },
      { id: 15, city: "Mancherial", lat: "18.8700", lng: "79.4500" },
      { id: 16, city: "Medak", lat: "18.0453", lng: "78.2608" },
      { id: 17, city: "Medchal–Malkajgiri", lat: "17.5500", lng: "78.6000" },
      { id: 18, city: "Mulugu", lat: "18.2000", lng: "79.9500" },
      { id: 19, city: "Nagarkurnool", lat: "16.4800", lng: "78.3200" },
      { id: 20, city: "Nalgonda", lat: "17.0541", lng: "79.2671" },
      { id: 21, city: "Narayanpet", lat: "16.7500", lng: "77.5000" },
      { id: 22, city: "Nirmal", lat: "19.1000", lng: "78.3500" },
      { id: 23, city: "Nizamabad", lat: "18.6725", lng: "78.0941" },
      { id: 24, city: "Peddapalli", lat: "18.6167", lng: "79.3667" },
      { id: 25, city: "Rajanna Sircilla", lat: "18.3833", lng: "78.8167" },
      { id: 26, city: "Ranga Reddy", lat: "17.3000", lng: "78.4000" },
      { id: 27, city: "Sangareddy", lat: "17.6242", lng: "78.0864" },
      { id: 28, city: "Siddipet", lat: "18.1018", lng: "78.8520" },
      { id: 29, city: "Suryapet", lat: "17.1500", lng: "79.6333" },
      { id: 30, city: "Vikarabad", lat: "17.3381", lng: "77.9046" },
      { id: 31, city: "Wanaparthy", lat: "16.3667", lng: "78.0667" },
      { id: 32, city: "Warangal", lat: "17.9784", lng: "79.5911" },
      { id: 33, city: "Yadadri Bhuvanagiri", lat: "17.5400", lng: "78.9000" },
    ],
  },
  {
    id: 25,
    label: "Tripura",
    district: [
      { id: 1, city: "Dhalai", lat: "23.9236", lng: "91.9990" },
      { id: 2, city: "Gomati", lat: "23.5000", lng: "91.5000" },
      { id: 3, city: "Khowai", lat: "24.0667", lng: "91.6333" },
      { id: 4, city: "North Tripura", lat: "24.3000", lng: "92.0167" },
      { id: 5, city: "Sepahijala", lat: "23.5411", lng: "91.3654" },
      { id: 6, city: "South Tripura", lat: "23.2078", lng: "91.5050" },
      { id: 7, city: "Unakoti", lat: "24.3136", lng: "92.0169" },
      { id: 8, city: "West Tripura", lat: "23.8315", lng: "91.2820" },
    ],
  },

  {
    id: 26,
    label: "Uttar Pradesh",
    district: [
      { id: 1, city: "Agra", lat: "27.1767", lng: "78.0081" },
      { id: 2, city: "Aligarh", lat: "27.8974", lng: "78.0880" },
      { id: 3, city: "Ambedkar Nagar", lat: "26.4340", lng: "82.5381" },
      { id: 4, city: "Amethi", lat: "26.1542", lng: "81.8146" },
      { id: 5, city: "Amroha", lat: "28.9031", lng: "78.4629" },
      { id: 6, city: "Auraiya", lat: "26.4632", lng: "79.5119" },
      { id: 7, city: "Ayodhya", lat: "26.7999", lng: "82.2040" },
      { id: 8, city: "Azamgarh", lat: "26.0720", lng: "83.1859" },
      { id: 9, city: "Baghpat", lat: "28.9440", lng: "77.2186" },
      { id: 10, city: "Bahraich", lat: "27.5743", lng: "81.5940" },
      { id: 11, city: "Ballia", lat: "25.7600", lng: "84.1500" },
      { id: 12, city: "Balrampur", lat: "27.4266", lng: "82.1877" },
      { id: 13, city: "Banda", lat: "25.4743", lng: "80.3358" },
      { id: 14, city: "Barabanki", lat: "26.9367", lng: "81.1896" },
      { id: 15, city: "Bareilly", lat: "28.3670", lng: "79.4304" },
      { id: 16, city: "Basti", lat: "26.8000", lng: "82.7500" },
      { id: 17, city: "Bhadohi", lat: "25.3949", lng: "82.5663" },
      { id: 18, city: "Bijnor", lat: "29.3730", lng: "78.1350" },
      { id: 19, city: "Budaun", lat: "28.0337", lng: "79.1212" },
      { id: 20, city: "Bulandshahr", lat: "28.4039", lng: "77.8570" },
      { id: 21, city: "Chandauli", lat: "25.2704", lng: "83.2707" },
      { id: 22, city: "Chitrakoot", lat: "25.1842", lng: "80.8742" },
      { id: 23, city: "Deoria", lat: "26.5090", lng: "83.7790" },
      { id: 24, city: "Etah", lat: "27.5591", lng: "78.6626" },
      { id: 25, city: "Etawah", lat: "26.7779", lng: "79.0215" },
      { id: 26, city: "Ayodhya", lat: "26.7999", lng: "82.2040" },
      { id: 27, city: "Farrukhabad", lat: "27.3906", lng: "79.5797" },
      { id: 28, city: "Fatehpur", lat: "25.9310", lng: "80.8128" },
      { id: 29, city: "Firozabad", lat: "27.1591", lng: "78.3957" },
      { id: 30, city: "Gautam Buddha Nagar", lat: "28.4744", lng: "77.5040" },
      { id: 31, city: "Ghaziabad", lat: "28.6692", lng: "77.4538" },
      { id: 32, city: "Ghazipur", lat: "25.5850", lng: "83.5800" },
      { id: 33, city: "Gonda", lat: "27.1340", lng: "81.9619" },
      { id: 34, city: "Gorakhpur", lat: "26.7606", lng: "83.3732" },
      { id: 35, city: "Hamirpur", lat: "25.9551", lng: "80.1492" },
      { id: 36, city: "Hapur", lat: "28.7306", lng: "77.7759" },
      { id: 37, city: "Hardoi", lat: "27.3943", lng: "80.1319" },
      { id: 38, city: "Hathras", lat: "27.6000", lng: "78.0500" },
      { id: 39, city: "Jalaun", lat: "26.1451", lng: "79.3377" },
      { id: 40, city: "Jaunpur", lat: "25.7460", lng: "82.6835" },
      { id: 41, city: "Jhansi", lat: "25.4484", lng: "78.5685" },
      { id: 42, city: "Kannauj", lat: "27.0510", lng: "79.9226" },
      { id: 43, city: "Kanpur Dehat", lat: "26.4290", lng: "79.8494" },
      { id: 44, city: "Kanpur Nagar", lat: "26.4499", lng: "80.3319" },
      { id: 45, city: "Kasganj", lat: "27.8000", lng: "78.6500" },
      { id: 46, city: "Kaushambi", lat: "25.3312", lng: "81.3831" },
      { id: 47, city: "Kheri", lat: "27.8974", lng: "80.7985" },
      { id: 48, city: "Kushinagar", lat: "26.7397", lng: "83.8897" },
      { id: 49, city: "Lalitpur", lat: "24.6900", lng: "78.4100" },
      { id: 50, city: "Lucknow", lat: "26.8467", lng: "80.9462" },
      { id: 51, city: "Maharajganj", lat: "27.1457", lng: "83.5656" },
      { id: 52, city: "Mahoba", lat: "25.2924", lng: "79.8725" },
      { id: 53, city: "Mainpuri", lat: "27.2310", lng: "79.0234" },
      { id: 54, city: "Mathura", lat: "27.4924", lng: "77.6737" },
      { id: 55, city: "Mau", lat: "25.9540", lng: "83.5612" },
      { id: 56, city: "Meerut", lat: "28.9845", lng: "77.7064" },
      { id: 57, city: "Mirzapur", lat: "25.1446", lng: "82.5644" },
      { id: 58, city: "Moradabad", lat: "28.8386", lng: "78.7733" },
      { id: 59, city: "Muzaffarnagar", lat: "29.4727", lng: "77.7085" },
      { id: 60, city: "Pilibhit", lat: "28.6312", lng: "79.8043" },
      { id: 61, city: "Pratapgarh", lat: "25.9167", lng: "81.9333" },
      { id: 62, city: "Prayagraj", lat: "25.4358", lng: "81.8463" },
      { id: 63, city: "Raebareli", lat: "26.2300", lng: "81.2400" },
      { id: 64, city: "Rampur", lat: "28.7980", lng: "79.0250" },
      { id: 65, city: "Saharanpur", lat: "29.9640", lng: "77.5460" },
      { id: 66, city: "Sambhal", lat: "28.5800", lng: "78.5500" },
      { id: 67, city: "Sant Kabir Nagar", lat: "26.7900", lng: "83.0700" },
      { id: 68, city: "Shahjahanpur", lat: "27.8804", lng: "79.9058" },
      { id: 69, city: "Shamli", lat: "29.4467", lng: "77.3103" },
      { id: 70, city: "Sharavasti", lat: "27.5454", lng: "81.9341" },
      { id: 71, city: "Siddharthnagar", lat: "27.2766", lng: "83.0718" },
      { id: 72, city: "Sitapur", lat: "27.5619", lng: "80.6885" },
      { id: 73, city: "Sonbhadra", lat: "24.6850", lng: "83.0681" },
      { id: 74, city: "Sultanpur", lat: "26.2639", lng: "82.0724" },
      { id: 75, city: "Unnao", lat: "26.5396", lng: "80.4878" },
    ],
  },
  {
    id: 27,
    label: "Uttarakhand",
    district: [
      { id: 1, city: "Almora", lat: "29.5970", lng: "79.6570" },
      { id: 2, city: "Bageshwar", lat: "29.8370", lng: "79.7700" },
      { id: 3, city: "Chamoli", lat: "30.4226", lng: "79.2151" },
      { id: 4, city: "Champawat", lat: "29.3352", lng: "80.0997" },
      { id: 5, city: "Dehradun", lat: "30.3165", lng: "78.0322" },
      { id: 6, city: "Haridwar", lat: "29.9457", lng: "78.1642" },
      { id: 7, city: "Nainital", lat: "29.3919", lng: "79.4542" },
      { id: 8, city: "Pauri Garhwal", lat: "30.1500", lng: "78.7833" },
      { id: 9, city: "Pithoragarh", lat: "29.5833", lng: "80.2167" },
      { id: 10, city: "Rudraprayag", lat: "30.2833", lng: "78.9833" },
      { id: 11, city: "Tehri Garhwal", lat: "30.3794", lng: "78.4438" },
      { id: 12, city: "Udham Singh Nagar", lat: "28.9884", lng: "79.4148" },
      { id: 13, city: "Uttarkashi", lat: "30.7298", lng: "78.4438" },
    ],
  },
  {
    id: 28,
    label: "West Bengal",
    district: [
      { id: 1, city: "Alipurduar", lat: "26.4837", lng: "89.5228" },
      { id: 2, city: "Bankura", lat: "23.2324", lng: "87.0735" },
      { id: 3, city: "Birbhum", lat: "23.8409", lng: "87.6186" },
      { id: 4, city: "Cooch Behar", lat: "26.3236", lng: "89.4459" },
      { id: 5, city: "Dakshin Dinajpur", lat: "25.3720", lng: "88.5950" },
      { id: 6, city: "Darjeeling", lat: "27.0360", lng: "88.2627" },
      { id: 7, city: "Hooghly", lat: "22.9088", lng: "88.3967" },
      { id: 8, city: "Howrah", lat: "22.5958", lng: "88.2636" },
      { id: 9, city: "Jalpaiguri", lat: "26.5435", lng: "88.7196" },
      { id: 10, city: "Jhargram", lat: "22.4500", lng: "86.9833" },
      { id: 11, city: "Kalimpong", lat: "27.0680", lng: "88.4654" },
      { id: 12, city: "Kolkata", lat: "22.5726", lng: "88.3639" },
      { id: 13, city: "Malda", lat: "25.0108", lng: "88.1411" },
      { id: 14, city: "Murshidabad", lat: "24.2290", lng: "88.2744" },
      { id: 15, city: "Nadia", lat: "23.4710", lng: "88.5565" },
      { id: 16, city: "North 24 Parganas", lat: "22.6338", lng: "88.4220" },
      { id: 17, city: "Paschim Bardhaman", lat: "23.6739", lng: "87.6792" },
      { id: 18, city: "Paschim Medinipur", lat: "22.4200", lng: "87.3191" },
      { id: 19, city: "Purba Bardhaman", lat: "23.2272", lng: "87.8615" },
      { id: 20, city: "Purba Medinipur", lat: "21.9400", lng: "87.7400" },
      { id: 21, city: "Purulia", lat: "23.3300", lng: "86.3650" },
      { id: 22, city: "South 24 Parganas", lat: "22.1386", lng: "88.5711" },
      { id: 23, city: "Uttar Dinajpur", lat: "25.6206", lng: "88.1207" },
    ],
  },
  {
    id: 29,
    label: "Andaman and Nicobar Islands",
    district: [
      { id: 1, city: "Nicobar", lat: "7.0000", lng: "93.7000" },
      { id: 2, city: "North and Middle Andaman", lat: "12.5000", lng: "92.7500" },
      { id: 3, city: "South Andaman", lat: "11.7401", lng: "92.6586" },
    ],
  },
  {
    id: 30,
    label: "Chandigarh",
    district: [{ id: 1, city: "Chandigarh", lat: "30.7333", lng: "76.7794" }],
  },
  {
    id: 31,
    label: "Dadra and Nagar Haveli and Daman and Diu",
    district: [
      { id: 1, city: "Dadra and Nagar Haveli", lat: "20.1809", lng: "73.0169" },
      { id: 2, city: "Daman", lat: "20.3974", lng: "72.8328" },
      { id: 3, city: "Diu", lat: "20.7140", lng: "70.9820" },
    ],
  },
  {
    id: 32,
    label: "Delhi",
    district: [
      { id: 1, city: "Central Delhi", lat: "28.6562", lng: "77.2244" },
      { id: 2, city: "East Delhi", lat: "28.6209", lng: "77.2931" },
      { id: 3, city: "New Delhi", lat: "28.6142", lng: "77.2023" },
      { id: 4, city: "North Delhi", lat: "28.7519", lng: "77.1881" },
      { id: 5, city: "North East Delhi", lat: "28.7250", lng: "77.2770" },
      { id: 6, city: "North West Delhi", lat: "28.7215", lng: "77.0689" },
      { id: 7, city: "Shahdara", lat: "28.6775", lng: "77.2890" },
      { id: 8, city: "South Delhi", lat: "28.5273", lng: "77.1384" },
      { id: 9, city: "South East Delhi", lat: "28.5509", lng: "77.2732" },
      { id: 10, city: "South West Delhi", lat: "28.5864", lng: "76.9798" },
      { id: 11, city: "West Delhi", lat: "28.6519", lng: "77.1177" },
    ],
  },
  {
    id: 33,
    label: "Jammu and Kashmir",
    district: [
      { id: 1, city: "Anantnag", lat: "33.7304", lng: "75.1500" },
      { id: 2, city: "Bandipora", lat: "34.5044", lng: "74.7628" },
      { id: 3, city: "Baramulla", lat: "34.2021", lng: "74.3480" },
      { id: 4, city: "Budgam", lat: "34.0186", lng: "74.7227" },
      { id: 5, city: "Doda", lat: "33.1490", lng: "75.5470" },
      { id: 6, city: "Ganderbal", lat: "34.2262", lng: "74.7749" },
      { id: 7, city: "Jammu", lat: "32.7266", lng: "74.8570" },
      { id: 8, city: "Kathua", lat: "32.3711", lng: "75.5273" },
      { id: 9, city: "Kishtwar", lat: "33.3117", lng: "75.7665" },
      { id: 10, city: "Kulgam", lat: "33.6440", lng: "75.0180" },
      { id: 11, city: "Kupwara", lat: "34.5300", lng: "74.2600" },
      { id: 12, city: "Poonch", lat: "33.7700", lng: "74.1000" },
      { id: 13, city: "Pulwama", lat: "33.8746", lng: "74.8999" },
      { id: 14, city: "Rajouri", lat: "33.3750", lng: "74.3000" },
      { id: 15, city: "Ramban", lat: "33.2357", lng: "75.2396" },
      { id: 16, city: "Reasi", lat: "33.0800", lng: "74.8300" },
      { id: 17, city: "Samba", lat: "32.5600", lng: "75.1200" },
      { id: 18, city: "Shopian", lat: "33.7200", lng: "74.8300" },
      { id: 19, city: "Srinagar", lat: "34.0837", lng: "74.7973" },
      { id: 20, city: "Udhampur", lat: "32.9300", lng: "75.1300" },
    ],
  },
  {
    id: 34,
    label: "Ladakh",
    district: [
      { id: 1, city: "Leh", lat: "34.1526", lng: "77.5771" },
      { id: 2, city: "Kargil", lat: "34.5614", lng: "76.1258" },
    ],
  },
  {
    id: 35,
    label: "Lakshadweep",
    district: [{ id: 1, city: "Lakshadweep", lat: "10.5667", lng: "72.6417" }],
  },
  {
    id: 36,
    label: "Puducherry",
    district: [
      { id: 1, city: "Puducherry", lat: "11.9139", lng: "79.8145" },
      { id: 2, city: "Karaikal", lat: "10.9254", lng: "79.8380" },
      { id: 3, city: "Mahe", lat: "11.7030", lng: "75.5360" },
      { id: 4, city: "Yanam", lat: "16.7331", lng: "82.2134" },
    ],
  },
];
